/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShowEvent200ResponseData } from './ShowEvent200ResponseData';
import {
    ShowEvent200ResponseDataFromJSON,
    ShowEvent200ResponseDataFromJSONTyped,
    ShowEvent200ResponseDataToJSON,
    ShowEvent200ResponseDataToJSONTyped,
} from './ShowEvent200ResponseData';

/**
 * 
 * @export
 * @interface ShowEvent200Response
 */
export interface ShowEvent200Response {
    /**
     * 
     * @type {ShowEvent200ResponseData}
     * @memberof ShowEvent200Response
     */
    data?: ShowEvent200ResponseData;
}

/**
 * Check if a given object implements the ShowEvent200Response interface.
 */
export function instanceOfShowEvent200Response(value: object): value is ShowEvent200Response {
    return true;
}

export function ShowEvent200ResponseFromJSON(json: any): ShowEvent200Response {
    return ShowEvent200ResponseFromJSONTyped(json, false);
}

export function ShowEvent200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowEvent200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ShowEvent200ResponseDataFromJSON(json['data']),
    };
}

export function ShowEvent200ResponseToJSON(json: any): ShowEvent200Response {
    return ShowEvent200ResponseToJSONTyped(json, false);
}

export function ShowEvent200ResponseToJSONTyped(value?: ShowEvent200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ShowEvent200ResponseDataToJSON(value['data']),
    };
}

